/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'mr': 'Herr',
    'ms': 'Frau',
    'salutation': 'Anrede'
  },

  /* english */
  en: {
    'mr': 'Mr',
    'ms': 'Ms',
    'salutation': 'Salutation'
  }
}
